import { css } from '@emotion/react';

const makeSubmissionBlockPageStyling = () => {
  return {
    icon: css({
      color: 'rgb(255, 151, 26)',
      fontSize: 50,
    }),
  };
};

export default makeSubmissionBlockPageStyling;
